<template>
  <div class="business">
    <div class="header">
      <p>
        Integrated Marketing Channels <br />
        Win-Win Cooperation
      </p>
    </div>
    <div class="guoyi animate__animated wow animate__fadeInUp">
      <titleCard title="GYT Strategic Layout"></titleCard>
      <div class="map-box" ref="myMap">
        <div class="map">
          <!-- <div class="onebox">
            <div class="one">
              <div class="image">
                <img src="../assets/image/business/one/1.png" alt="" />
              </div>
              <div class="text">
                <h3>
                  Canature Kang De Wei Health Technology(Beijing) Co.,Ltd.
                </h3>
                <p>2019-03-08 found</p>
              </div>
            </div>
            <div class="one">
              <div class="image">
                <img src="../assets/image/business/one/2.png" alt="" />
              </div>
              <div class="text">
                <h3>
                  Guoyi Yanchang (Beijing) Medical Technology Service Co.,Ltd
                </h3>
                <p>2018-09-06 found</p>
              </div>
            </div>
            <div class="one">
              <div class="image">
                <img src="../assets/image/business/one/3.png" alt="" />
              </div>
              <div class="text">
                <h3>Beijing Dejia Innovative Medical Devices Co., Ltd</h3>
                <p>2014-11-14 found</p>
              </div>
            </div>
            <div class="one">
              <div class="image">
                <img src="../assets/image/business/one/4.png" alt="" />
              </div>
              <div class="text">
                <h3>Yunyitong(Beijing)lnformationTechnology Co.,Ltd</h3>
                <p>2021-03-09 found</p>
              </div>
            </div>
          </div>
          <div class="twobox">
            <div class="two">
              <div class="image">
                <img src="../assets/image/business/two/1.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #64b383">
                  Harbin Chenxiang Yifu TechnologyDevelopment Co.,Ltd
                </h3>
                <p>2015-05-06 found</p>
              </div>
            </div>
            <div class="two">
              <div class="image">
                <img src="../assets/image/business/two/2.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #3cb3b8">
                  lnner Mongolia Branch of guoyitongTechnology Development
                  Co.,Ltd
                </h3>
                <p>2019-07-01 found</p>
              </div>
            </div>
            <div class="two two2">
              <div class="image">
                <img src="../assets/image/business/two/3.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #45cbd5">
                  Guoyitong (Shandong) MedicalTechnology Development Co., Ltd
                </h3>
                <p>2018-11-27 found</p>
              </div>
            </div>
            <div class="two two3">
              <div class="image">
                <img src="../assets/image/business/two/4.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #f3704a">
                  Guoyitong (Jiangsu) Medical Technology Development Co.,Ltd
                </h3>
                <p>2022-01-24 found</p>
              </div>
            </div>
            <div class="two">
              <div class="image">
                <img src="../assets/image/business/two/5.png" alt="" />
              </div>
              <div class="text">
                <h3 style="color: #ee8162">
                  Guoyitong (xiamen) Medical Technology Development Co.,Ltd
                </h3>
                <p>2021-10-22 found</p>
              </div>
            </div>
          </div> -->
        </div>
        <div class="p">
          <p class="one">
            Business has covered all provinces,<br />
            municipalities and autonomous regions <br />in China except Tibet
            and Taiwan
          </p>
          <!-- <p class="two">全国范围库房数量达<span>30+</span></p> -->
        </div>
      </div>
    </div>
    <div class="changjing">
      <div class="title">
        <titleCard title="Scenario Solutions"></titleCard>
      </div>
      <!-- PC -->
      <div class="content-box">
        <div class="box">
          <div
            class="box-pic animate__animated wow animate__fadeInLeft"
            data-wow-duration="1s"
          >
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/C1A7E390B1CE4775AAA584E64A4087E2-6-2.png"
              alt=""
            />
          </div>
          <div
            class="box-txt animate__animated wow animate__fadeInRight"
            data-wow-duration="1.4s"
          >
            <p>
              GYT now has 7 branches and various marketing channels integration
              methods, including structure integration, partnership integration,
              process integration, sales terminal integration, customer
              integration and the integration with marketing channel elements
              such as price and brand, thus building up its flexible channel
              system and forming a mixed, vertical or horizontal multi-channel
              system.
            </p>
          </div>
        </div>
        <div class="box">
          <div
            class="box-txt animate__animated wow animate__fadeInLeft"
            data-wow-duration="1.4s"
          >
            <p>
              Meanwhile, a win-win cooperation business mode is formed
              considering both the demands of upstream industrial manufacturers
              and downstream customers.
            </p>
          </div>
          <div
            class="box-pic animate__animated wow animate__fadeInRight"
            data-wow-duration="1s"
          >
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/4E96C123D9AD45619631FD3992E44B2B-6-2.png"
              alt=""
            />
          </div>
        </div>
        <div class="box">
          <div
            class="box-pic animate__animated wow animate__fadeInLeft"
            data-wow-duration="1s"
          >
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/406F2E78CB5D4E54969E836E5570BE88-6-2.png"
              alt=""
            />
          </div>
          <div
            class="box-txt animate__animated wow animate__fadeInRight"
            data-wow-duration="1.4s"
          >
            <h3>
              Focus on providing one-stop warehouse hosting services for
              customers
            </h3>
            <p>
              Save time and costs for customers, determined to be the faithful
              custodian of the storage of its customers!
            </p>
          </div>
        </div>
      </div>
      <!-- IOS -->
      <div class="content-Iosbox">
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/C1A7E390B1CE4775AAA584E64A4087E2-6-2.png"
              alt=""
            />
          </div>
          <div class="txt">
            <p>
              GYT now has 7 branches and various marketing channels integration
              methods, including structure integration, partnership integration,
              process integration, sales terminal integration, customer
              integration and the integration with marketing channel elements
              such as price and brand, thus building up its flexible channel
              system and forming a mixed, vertical or horizontal multi-channel
              system.
            </p>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/4E96C123D9AD45619631FD3992E44B2B-6-2.png"
              alt=""
            />
          </div>
          <div class="txt">
            <p>
              Meanwhile, a win-win cooperation business mode is formed
              considering both the demands of upstream industrial manufacturers
              and downstream customers.
            </p>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img
              src="https://yyt-ows.oss-cn-beijing.aliyuncs.com/406F2E78CB5D4E54969E836E5570BE88-6-2.png"
              alt=""
            />
          </div>
          <div class="txt">
            <h3>
              Focus on providing one-stop warehouse hosting services for
              customers
            </h3>
            <p>
              Save time and costs for customers, determined to be the faithful
              custodian of the storage of its customers!
            </p>
          </div>
        </div>
      </div>
      <div class="hezuo animate__animated wow animate__fadeInUp">
        <titleCard title="Partners"></titleCard>
      </div>
    </div>
    <div class="hezuo-content animate__animated wow animate__fadeInUp">
      <!-- PC展示 -->
      <div class="cards">
        <div class="cardX">
          <div class="card">
            <img src="../assets/image/business/icon1.png" />
          </div>
          <div class="card">
            <img src="../assets/image/business/icon2.png" />
          </div>
          <div class="card">
            <img src="../assets/image/business/icon3.png" />
          </div>
          <div class="card">
            <img src="../assets/image/business/icon4.png" />
          </div>
        </div>
        <div class="cardX">
          <div class="card">
            <img src="../assets/image/business/icon5.png" />
          </div>
          <div class="card">
            <img src="../assets/image/business/icon6.png" />
          </div>
          <div class="card">
            <img src="../assets/image/business/icon7.png" />
          </div>
          <div class="card">
            <img src="../assets/image/business/icon8.png" />
          </div>
        </div>
        <div class="cardX">
          <div class="card">
            <img src="../assets/image/business/icon9.png" />
          </div>
          <div class="card">
            <img src="../assets/image/business/icon10.png" />
          </div>
          <div class="card">
            <img src="../assets/image/business/icon11.png" />
          </div>
          <div class="card">
            <img src="../assets/image/business/icon12.png" />
          </div>
        </div>
      </div>
      <!-- IOS展示 -->
      <div class="cardIos">
        <div class="card">
          <img src="../assets/image/business/icon1.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon2.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon3.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon4.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon5.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon6.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon7.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon8.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon9.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon10.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon11.png" />
        </div>
        <div class="card">
          <img src="../assets/image/business/icon12.png" />
        </div>
      </div>
      <p>— Partial display —</p>
    </div>
    <footerCard name="Mr Chen" phone="138-1017-5809"></footerCard>
  </div>
</template>

<script>
// import WOW from "../../node_modules/wowjs/dist/wow";
import titleCard from "../components/title-card.vue";
import footerCard from "../components/footer-card.vue";
export default {
  data() {
    return {};
  },
  components: {
    titleCard,
    footerCard,
  },
  created() {},
  mounted() {
    this.$refs.myMap.scrollLeft = 350;
    // let wow = new WOW.WOW({
    //   boxClass: "wow",
    //   animateClass: "animated",
    //   offset: 0,
    //   mobile: true,
    //   live: true,
    // });
    // wow.init();
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.business {
  // background-color: #fbfbfb;
  .header {
    height: 5.2632rem;
    width: 100%;
    display: flex;
    background-color: lightblue;
    align-items: center;
    margin-bottom: 0.8421rem;
    background: url("../assets/image/business/headimg.webp") no-repeat;
    background-size: 100% 100%;
    justify-content: center;
    @media screen and (max-width: 540px) {
      background-size: 230% 100%;
      background-position: center;
      height: 250px;
    }
    p {
      color: #ffffff;
      text-align: center;
      letter-spacing: 0.0421rem;
      font-size: 0.4211rem;
      font-weight: 700;
      text-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      @media screen and (max-width: 540px) {
        font-size: 20px;
      }
    }
  }
  .guoyi {
    .map-box::-webkit-scrollbar {
      display: none;
    }
    .map-box {
      background-color: #ffffff !important;
      margin-bottom: 0.1684rem;
      height: 11.1579rem;
      width: 100%;
      position: relative;
      @media screen and (max-width: 540px) {
        height: 680px;
        margin-bottom: 50px;
        overflow: scroll;
        overflow-y: hidden;
      }
      .map {
        position: relative;
        width: 100%;
        height: 100%;
        background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/6FB1D6F6CD7B4DC38577AC56680BF980-6-2.png") no-repeat;
        background-size: 100% 100%;
        @media screen and (max-width: 540px) {
          background: url("https://yyt-ows.oss-cn-beijing.aliyuncs.com/6FB1D6F6CD7B4DC38577AC56680BF980-6-2.png") no-repeat;
          background-position-x: 40%;
          background-size: cover;
          width: 1260px;
          margin: 30px 0;
        }
        .onebox {
          @media screen and (max-width: 540px) {
            display: none;
          }
          position: absolute;
          left: 2.2rem;
          top: 0.4rem;
          width: 9rem;
          height: 3rem;
          display: flex;
          flex-wrap: wrap;
          align-items: flex-end;
          .one {
            width: 50%;
            height: 0.8rem;
            display: flex;
            align-items: center;
            .image {
              width: 0.8rem;
              height: 0.8rem;
              margin-right: 0.1rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .text {
              flex: 1;
              font-size: 0.18rem;
              h3 {
                font-size: 0.18rem;
                margin: 0;
                color: #0ca6eb;
                margin-bottom: 0.1rem;
              }
            }
          }
        }
        .twobox {
          @media screen and (max-width: 540px) {
            display: none;
          }
          position: absolute;
          right: 2rem;
          top: 1.7rem;
          width: 5.2rem;
          height: 5rem;
          .two2 {
            margin-bottom: 0.21rem !important;
          }
          .two3 {
            margin-bottom: 0.45rem !important;
          }
          .two {
            width: 100%;
            height: 0.8rem;
            display: flex;
            align-items: center;
            margin-bottom: 0.4rem;
            .image {
              width: 0.8rem;
              height: 0.8rem;
              margin-right: 0.1rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .text {
              flex: 1;
              font-size: 0.2rem;
              h3 {
                font-size: 0.19rem;
                margin: 0;
                color: #0ca6eb;
                margin-bottom: 0.1rem;
              }
            }
          }
        }
      }
      .p {
        position: absolute;
        left: 1.7684rem;
        bottom: 0.9263rem;
        color: #333333;
        line-height: 0.5053rem;
        font-size: 0.3368rem;
        @media screen and (max-width: 540px) {
          left: 10px;
          bottom: 0;
          font-size: 16px;
          line-height: 28px;
        }
        span {
          font-size: 0.5895rem;
          padding: 0 0.1053rem;
          color: #0ca6eb;
          font-weight: 700;
          @media screen and (max-width: 540px) {
            font-size: 28px;
          }
        }
        .one {
          padding-bottom: 0.5263rem;
        }
        .two {
          display: flex;
        }
      }
    }
  }
  .changjing {
    background-color: #fff;
    .title {
      padding: 1.0526rem 0 1.9474rem 0;
    }
    .content-box {
      padding: 0 1.7053rem;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .box {
        display: flex;
        align-items: center;
        height: 5.1579rem;
        padding-bottom: 0.6947rem;
        .box-pic {
          height: 5.1579rem;
          flex: 1;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .box-txt {
          flex: 1;
          h3 {
            color: #0ca6eb;
            font-size: 0.2947rem;
            margin: 0;
            padding-left: 0.7789rem;
            padding-bottom: 0.6316rem;
          }
          p {
            padding-left: 0.7789rem;
            color: #666666;
            line-height: 0.4632rem;
            font-size: 0.2526rem;
          }
        }
      }
    }
    .content-Iosbox {
      display: none;
      padding-top: 32px;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .box {
        padding: 0 14px;
        padding-bottom: 32px;
        .pic {
          height: 260px;
          width: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .txt {
          padding: 18px;
          h3 {
            text-align: center;
            color: #0ca6eb;
            font-size: 15px;
          }
          p {
            font-size: 14px;
            line-height: 22px;
            color: #666666;
            text-align: center;
          }
        }
      }
    }
    .hezuo {
      padding: 0.7368rem 0 0.8421rem 0;
    }
  }
  .hezuo-content {
    // height: 7.5579rem;
    @media screen and (max-width: 540px) {
      background-color: #f5f5f5;
    }
    .cards {
      @media screen and (max-width: 540px) {
        display: none;
      }
      padding: 0.7263rem 0 0 0;
      .cardX {
        display: flex;
        justify-content: center;
        margin-bottom: 0.6842rem;
        .card {
          margin: 0 0.0842rem;
          width: 3.9368rem;
          height: 1.3684rem;
          display: flex;
          align-items: center;
          background-color: #fff;
          justify-content: center;
          border: 1px solid #eeeeee;
          border-radius: 0.0421rem;
          img {
            height: 100%;
            width: 100%;
          }
        }
      }
    }
    .cardIos {
      display: none;
      padding: 33px 0;
      @media screen and (max-width: 540px) {
        display: block;
        overflow: hidden;
      }
      .card {
        width: 30%;
        height: 44px;
        float: left;
        background-color: #fff;
        border: 1px solid #eeeeee;
        border-radius: 0.0421rem;
        display: flex;
        margin: 0 5px;
        margin-top: 10px;
        justify-content: center;
        align-items: center;
        img {
          height: 100%;
          width: 100%;
        }
      }
    }
    p {
      color: #c0c0c0;
      font-size: 0.2947rem;
      font-weight: 400;
      text-align: center;
      padding-bottom: 0.5263rem;
      @media screen and (max-width: 540px) {
        padding-bottom: 30px;
      }
    }
  }
}
</style>
